import {
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS,
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED,
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED,
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT,
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED,
  GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED,
  UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT,
  UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED,
  UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED,
  SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS,
  SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED,
  SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  staffRoleDiscountRateLimits: [],
  staffRoleDiscountRateLimitsLoading: false,
  staffRoleDiscountRateLimitsError: null,
  staffRoleDiscountRateLimit: null,
  staffRoleDiscountRateLimitLoading: false,
  staffRoleDiscountRateLimitError: null,
  updatingStaffRoleDiscountRateLimit: false,
  search: searchDefault,
};

const staffRoleDiscountRateLimitReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS:
      return handleSearch(state, 'search', action.payload);
    case SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED:
      return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED:
      return handleSearchFailed(state, 'search', action.payload);
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS: {
      return {
        ...state,
        staffRoleDiscountRateLimitsLoading: true,
        staffRoleDiscountRateLimits: [],
        staffRoleDiscountRateLimitsError: null,
      };
    }
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_COMPLETED: {
      return {
        ...state,
        staffRoleDiscountRateLimitsLoading: false,
        staffRoleDiscountRateLimits: action.payload.data,
      };
    }
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMITS_FAILED: {
      return {
        ...state,
        staffRoleDiscountRateLimitsLoading: false,
        staffRoleDiscountRateLimitsError: action.payload,
      };
    }
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT: {
      return {
        ...state,
        staffRoleDiscountRateLimitLoading: true,
        staffRoleDiscountRateLimit: null,
        staffRoleDiscountRateLimitError: null,
      };
    }
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED: {
      return {
        ...state,
        staffRoleDiscountRateLimitLoading: false,
        staffRoleDiscountRateLimit: action.payload,
      };
    }
    case GET_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED: {
      return {
        ...state,
        staffRoleDiscountRateLimitLoading: false,
        staffRoleDiscountRateLimitError: action.payload,
      };
    }
    case UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT: {
      return {
        ...state,
        updatingStaffRoleDiscountRateLimit: true,
      };
    }
    case UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_COMPLETED: {
      return {
        ...state,
        updatingStaffRoleDiscountRateLimit: false,
      };
    }
    case UPDATE_STAFF_ROLE_DISCOUNT_RATE_LIMIT_FAILED: {
      return {
        ...state,
        updatingStaffRoleDiscountRateLimit: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default staffRoleDiscountRateLimitReducer;



// WEBPACK FOOTER //
// ./src/StaffRoleDiscountRateLimit/reducer.js